'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavbarComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NavbarComponent = exports.NavbarComponent = function () {
  function NavbarComponent(Auth, ngToast, $http, Build) {
    'ngInject';

    _classCallCheck(this, NavbarComponent);

    this.menu = [];
    this.isCollapsed = true;
    this._Build = Build;
    this.$http = $http;
    this._$ngToast = ngToast;
    this.isNotFreight = Auth.isNotFreightSync;
    this.isLoggedIn = Auth.isLoggedInSync;
    this.isAdmin = Auth.isAdminSync;
    this.getCurrentUser = Auth.getCurrentUserSync;
  }

  _createClass(NavbarComponent, [{
    key: 'trigger',
    value: function trigger() {
      var _this = this;

      console.log('test');
      this._Build.trigger().then(function (res) {
        console.log('Result', res);
        _this._$ngToast.info({ dismissButton: true, content: 'Build triggered successfully. Please wait at least 3 minutes before building again.' });
      }).catch(function (err) {
        console.log('Error', err);
        _this._$ngToast.danger({ dismissButton: true, content: 'Build trigger failed.' });
      });
    }
  }]);

  return NavbarComponent;
}();

exports.default = _angular2.default.module('directives.navbar', []).component('navbar', {
  template: require('./navbar.pug'),
  controller: NavbarComponent
}).name;


// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js